// src/screens/admin/students/Students.js
import React, { useContext, useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Table,
  Button,
  Form,
  Badge,
  Modal,
  InputGroup,
} from "react-bootstrap";
import AdminLayout from "../../../layouts/admin/adminlayout/AdminLayout";
import "../../../assets/css/admin/students/Students.css";
import axios from "axios";
import AppContext from "../../../context/AppContext";

const Students = () => {
  const { baseUrl } = useContext(AppContext);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterStatus, setFilterStatus] = useState("all");
  const [showModal, setShowModal] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);

  // Sample Students Data
  const [students, setStudents] = useState([]);

  const getStudentStats = () => {
    axios
      .post(`${baseUrl}/admin/stats/studentStats`)
      .then((response) => {
        console.log(response.data);
        setStudents(response.data.students);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleViewStudent = (student) => {
    setSelectedStudent(student);
    setShowModal(true);
  };

  const handleDeleteStudent = (id) => {
    if (window.confirm("Are you sure you want to delete this student?")) {
      setStudents(students.filter((s) => s.id !== id));
    }
  };

  const handleToggleStatus = (id) => {
    setStudents(
      students.map((s) =>
        s.id === id
          ? { ...s, status: s.status === "active" ? "blocked" : "active" }
          : s,
      ),
    );
  };

  useEffect(()=>{
    getStudentStats();
  },[])

  return (
    <AdminLayout>
      <div className="students-page">
        {/* Page Header */}
        <div className="page-header mb-4">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h2 className="page-title">
                <span className="page-icon">👥</span>
                Students Management
              </h2>
              <p className="text-muted">Manage all registered students</p>
            </div>
            <Button
              variant="primary"
              size="lg"
              className="add-student-btn"
              onClick={() => setShowAddModal(true)}
            >
              Add New Student
            </Button>
          </div>
        </div>

        {/* Stats Cards */}
        <Row className="mb-4">
          <Col lg={3} md={6} className="mb-3">
            <Card className="stat-card stat-card-blue">
              <Card.Body>
                <div className="stat-icon">👨‍🎓</div>
                <div className="stat-info">
                  <h3>{students.length}</h3>
                  <p>Total Students</p>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col lg={3} md={6} className="mb-3">
            <Card className="stat-card stat-card-green">
              <Card.Body>
                <div className="stat-icon">✅</div>
                <div className="stat-info">
                  <h3>
                    {students.filter((s) => s.status === "active").length}
                  </h3>
                  <p>Active Students</p>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col lg={3} md={6} className="mb-3">
            <Card className="stat-card stat-card-red">
              <Card.Body>
                <div className="stat-icon">🚫</div>
                <div className="stat-info">
                  <h3>
                    {students.filter((s) => s.status === "blocked").length}
                  </h3>
                  <p>Blocked Students</p>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col lg={3} md={6} className="mb-3">
            <Card className="stat-card stat-card-orange">
              <Card.Body>
                <div className="stat-icon">📚</div>
                <div className="stat-info">
                  <h3>12</h3>
                  <p>Study Groups</p>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Filters & Search */}
        <Card className="mb-4">
          <Card.Body>
            <Row className="align-items-center">
              <Col lg={6} className="mb-3 mb-lg-0">
                <InputGroup>
                  <InputGroup.Text>
                    <i className="bi bi-search"></i>
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    placeholder="Search by name or email..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </InputGroup>
              </Col>
              <Col lg={3} className="mb-3 mb-lg-0">
                <Form.Select
                  value={filterStatus}
                  onChange={(e) => setFilterStatus(e.target.value)}
                >
                  <option value="all">All Status</option>
                  <option value="active">Active</option>
                  <option value="blocked">Blocked</option>
                </Form.Select>
              </Col>
              <Col lg={3}>
                <Button variant="outline-secondary" className="w-100">
                  <i className="bi bi-funnel"></i> More Filters
                </Button>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        {/* Students Table */}
        <Card>
          <Card.Body>
            <div className="table-responsive">
              <Table hover className="students-table">
                <thead>
                  <tr>
                    <th>Student</th>
                    <th>Email</th>
                    <th>Status</th>
                    <th>Study Groups</th>
                    <th>Joined Date</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {students.map((student) => (
                    <tr key={student.id}>
                      <td>
                        <div className="d-flex align-items-center">
                          <img
                            src={student.image}
                            alt={student.name}
                            className="student-avatar"
                          />
                          <span className="fw-bold ms-2">{student.name}</span>
                        </div>
                      </td>
                      <td>{student.email}</td>
                      <td>
                        <Badge
                          bg={
                            student.status === "active" ? "success" : "danger"
                          }
                        >
                          {student.status === "active" ? "Active" : "Blocked"}
                        </Badge>
                      </td>
                      {/* <td>
                        <div className="study-groups-badges">
                          {student.studyGroups.slice(0, 2).map((group, idx) => (
                            <Badge key={idx} bg="info" className="me-1">
                              {group}
                            </Badge>
                          ))} */}
                          {/* {student.studyGroups.length > 2 && (
                            <Badge bg="secondary">
                              +{student.studyGroups.length - 2}
                            </Badge>
                          )} */}
                      {/* </tr></div>
                      </td> */}
                      <td>{10}</td>
                      <td>{new Date(student.created_at).toLocaleDateString()}</td>
                      <td>
                        <div className="action-buttons">
                          <Button
                            variant="outline-primary"
                            size="sm"
                            className="me-1"
                            onClick={() => handleViewStudent(student)}
                          >
                            <i className="bi bi-eye"></i>
                          </Button>
                          <Button
                            variant="outline-warning"
                            size="sm"
                            className="me-1"
                            onClick={() => handleToggleStatus(student.id)}
                          >
                            <i className="bi bi-shield-lock"></i>
                          </Button>
                          <Button
                            variant="outline-danger"
                            size="sm"
                            onClick={() => handleDeleteStudent(student.id)}
                          >
                            <i className="bi bi-trash"></i>
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </Card.Body>
        </Card>

        {/* View Student Modal */}
        <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Student Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedStudent && (
              <div className="student-details">
                <div className="text-center mb-4">
                  <img
                    src={selectedStudent.image}
                    alt={selectedStudent.name}
                    className="student-avatar-large"
                  />
                  <h4 className="mt-3">{selectedStudent.name}</h4>
                  <Badge
                    bg={
                      selectedStudent.status === "active" ? "success" : "danger"
                    }
                  >
                    {selectedStudent.status}
                  </Badge>
                </div>
                <Row>
                  <Col md={6}>
                    <p>
                      <strong>Email:</strong> {selectedStudent.email}
                    </p>
                    <p>
                      <strong>Phone:</strong> {selectedStudent.phone}
                    </p>
                  </Col>
                  <Col md={6}>
                    <p>
                      <strong>Joined:</strong> {selectedStudent.joinedDate}
                    </p>
                    {/* <p>
                      <strong>Groups:</strong>{" "}
                      {selectedStudent.studyGroups.length}
                    </p> */}
                  </Col>
                </Row>
                <hr />
                <h6>Study Groups:</h6>
                <div className="mb-3">
                  {selectedStudent.studyGroups.map((group, idx) => (
                    <Badge key={idx} bg="info" className="me-2 mb-2">
                      {group}
                    </Badge>
                  ))}
                </div>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)}>
              Close
            </Button>
            <Button variant="primary">Edit Student</Button>
          </Modal.Footer>
        </Modal>

        {/* Add Student Modal */}
        <Modal show={showAddModal} onHide={() => setShowAddModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Add New Student</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Full Name</Form.Label>
                <Form.Control type="text" placeholder="Enter full name" />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control type="email" placeholder="Enter email" />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Phone</Form.Label>
                <Form.Control type="text" placeholder="Enter phone number" />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Study Groups</Form.Label>
                <Form.Select>
                  <option>Select study group</option>
                  <option>React Advanced</option>
                  <option>Mathematics 101</option>
                  <option>Physics Lab</option>
                </Form.Select>
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowAddModal(false)}>
              Cancel
            </Button>
            <Button variant="primary">Add Student</Button>
          </Modal.Footer>
        </Modal>
      </div>
    </AdminLayout>
  );
};

export default Students;
